import { useState } from "react";
import { useDispatch } from "react-redux";

import axiosApi from "../axios";

import { addNotification } from "../../store/actions/notifierActions";

const usePrintPdf = (fileHash) => {
  const dispatch = useDispatch();

  const [downloadOptions, setDownloadOptions] = useState({
    loaded: 0,
    total: 0,
    progress: 0,
    downloadStarted: false,
  });
  const [fileName, setFileName] = useState("");

  const printPdfHandler = async () => {
    const options = {
      onDownloadProgress: (progressEvent) => {
        const { loaded, total, progress } = progressEvent;
        setDownloadOptions({
          loaded,
          total,
          progress: progress * 100,
          downloadStarted: loaded && progress > 0 ? true : false,
        });
      },
    };
    try {
      const response = await axiosApi.post(`/api/cdr/print-pdf/${fileHash}`, {
        responseType: "blob",
        ...options,
      });
      const fileName =
        response.headers["content-disposition"].split("filename=")[1] || "downloaded_cdr";
      setFileName(fileName);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      setDownloadOptions((options) => ({ ...options, downloadStarted: false }));
      const errorMessage = err?.response?.data?.message || "";
      dispatch(
        addNotification({
          message:
            err.response.status === 404
              ? "Sample not found"
              : errorMessage === "CDR is not enabled"
              ? errorMessage
              : "Print pdf failed",
          options: { variant: "error" },
          time: 3000,
        }),
      );
    } finally {
      setTimeout(() => {
        setDownloadOptions((options) => ({ ...options, downloadStarted: false }));
      }, 1500);
    }
  };

  return { downloadOptions, fileName, printPdfHandler };
};

export default usePrintPdf;
